import c from "../Constants";
import $ from 'jquery';

require('es6-promise').polyfill();
require('isomorphic-fetch');


var aplicacionesLaborales = {

    saveCreate(nuevo, file) {
        var formData = new FormData();
        if (file) {
            formData.append(file.name, file);
        }
        formData.append("aplicacionLaboral", JSON.stringify(nuevo));
        return $.ajax({
            url: c.BASE_URL + '/api/aplicacionesLaborales',
            //dataType: 'json',
            data: formData,
            beforeSend: function (xhr) {
                xhr.setRequestHeader('authorization', localStorage.token);
            },
            contentType: false,
            type: 'POST',
            processData: false,
            enctype: 'multipart/form-data',
        });

    },
};

export default aplicacionesLaborales;


// WEBPACK FOOTER //
// ./src/api/aplicacionesLaborales.js